<script>
    // 헤더 공용 계정 메뉴 (홈/봇 빌더/챗 빌더 통일).
    // 아바타(이니셜) + 이메일 트리거 → 드롭다운(계정설정 / 관리자 / 로그아웃).
    // planStore에서 emailId/authType 구독, 로그아웃 자체 처리 → 어느 헤더에 넣어도 동작.
    import { onDestroy, onMount } from "svelte";
    import { navigateTo } from "svelte-router-spa";
    import { PRConnect } from "@projectroom/ui-lib";
    import { _, locale, getLocaleFromNavigator } from "svelte-i18n";
    import Cookies from "js-cookie";
    import { planStore } from "../store/plan-store";
    import { accessToken } from "../store/auth-store";

    export let showEmail = true; // 빌더 톱바처럼 좁은 곳은 false(아바타만)

    let isOpen = false;
    let emailId = "";
    let authType;
    let sub;

    onMount(() => {
        sub = planStore.subscribe((m) => {
            emailId = m?.emailId || "";
            authType = m?.authType;
        });
    });
    onDestroy(() => sub && sub());

    // 언어 선택: 헤더 셀렉트에서 계정 메뉴로 이관. 3개뿐이라 세그먼트 토글로.
    const langs = [
        { value: "ko", label: "한국어" },
        { value: "en", label: "EN" },
        { value: "ja", label: "日本語" },
    ];
    let lang = Cookies.get("lang") || getLocaleFromNavigator().substring(0, 2);
    const setLang = (value) => {
        locale.set(value);
        Cookies.set("lang", value, { expires: 365 });
        lang = value;
    };

    $: initial = (emailId || "?").charAt(0).toUpperCase();

    const go = (path) => {
        isOpen = false;
        navigateTo(path);
    };

    const logout = () => {
        PRConnect.send("/api/Auth/logout", {}, (data) => {
            if (data.header.status === "success") {
                accessToken.set(null);
                planStore.setInitializeFlag();
                navigateTo("/login");
            }
        });
    };
</script>

<svelte:window on:click={() => (isOpen = false)} />

<div class="acct" on:click|stopPropagation>
    <button type="button" class="acct-trigger" on:click={() => (isOpen = !isOpen)}>
        <span class="acct-avatar">{initial}</span>
        {#if showEmail}
            <span class="acct-email">{emailId}</span>
        {/if}
        <svg
            class="acct-chevron"
            class:open={isOpen}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"><path d="m6 9 6 6 6-6" /></svg
        >
    </button>
    {#if isOpen}
        <div class="acct-menu">
            <div class="acct-menu-head">
                <span class="acct-avatar lg">{initial}</span>
                <div class="acct-menu-id">
                    <div class="acct-menu-email">{emailId}</div>
                    {#if authType}<div class="acct-menu-role">{authType}</div>{/if}
                </div>
            </div>
            <button type="button" class="acct-item" on:click={() => go("/account")}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4" /><path d="M6 21v-1a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v1" /></svg>
                {$_("project.common.19")}
            </button>
            {#if authType === "ADMIN"}
                <div class="acct-sep"></div>
                <button type="button" class="acct-item" on:click={() => go("/admin")}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
                    {$_("project.common.20")}
                </button>
                <button type="button" class="acct-item" on:click={() => go("/admin-event")}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1Z" /><path d="M8 7h8M8 11h6" /></svg>
                    {$_("project.common.21")}
                </button>
                <button type="button" class="acct-item" on:click={() => go("/admin-avatalk")}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>
                    아바톡 관리
                </button>
                <button type="button" class="acct-item" on:click={() => go("/admin-ai-chat")}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="10" x="3" y="11" rx="2" /><circle cx="12" cy="5" r="2" /><path d="M12 7v4" /><line x1="8" x2="8" y1="16" y2="16" /><line x1="16" x2="16" y1="16" y2="16" /></svg>
                    AI 챗 관리
                </button>
            {/if}
            <div class="acct-sep"></div>
            <div class="acct-lang-row">
                <span class="acct-lang-label">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10" /><path d="M2 12h20" /><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" /></svg>
                    언어
                </span>
                <div class="acct-lang-seg">
                    {#each langs as l (l.value)}
                        <button type="button" class="acct-lang-opt" class:active={lang === l.value} on:click={() => setLang(l.value)}>{l.label}</button>
                    {/each}
                </div>
            </div>
            <div class="acct-sep"></div>
            <button type="button" class="acct-item danger" on:click={logout}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" x2="9" y1="12" y2="12" /></svg>
                {$_("project.common.22")}
            </button>
        </div>
    {/if}
</div>

<style>
    .acct {
        position: relative;
        display: flex;
        align-items: center;
        font-family: "Noto Sans KR", sans-serif;
    }
    .acct-trigger {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 5px 12px 5px 5px;
        border: 1px solid hsl(var(--sb-border));
        border-radius: 999px;
        background: hsl(var(--sb-card));
        cursor: pointer;
        transition:
            background 0.15s,
            border-color 0.15s;
    }
    .acct-trigger:hover {
        background: hsl(var(--sb-muted));
        border-color: hsl(var(--sb-primary) / 0.4);
    }
    .acct-avatar {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        border-radius: 999px;
        background: hsl(var(--sb-primary));
        color: hsl(var(--sb-primary-foreground));
        font-size: 13px;
        font-weight: 700;
        flex-shrink: 0;
    }
    .acct-avatar.lg {
        width: 40px;
        height: 40px;
        font-size: 16px;
    }
    .acct-email {
        max-width: 180px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 13px;
        font-weight: 500;
        color: hsl(var(--sb-foreground));
    }
    .acct-chevron {
        width: 16px;
        height: 16px;
        color: hsl(var(--sb-muted-foreground));
        transition: transform 0.18s;
    }
    .acct-chevron.open {
        transform: rotate(180deg);
    }
    .acct-menu {
        position: absolute;
        top: calc(100% + 8px);
        right: 0;
        z-index: 50;
        min-width: 244px;
        padding: 6px;
        border: 1px solid hsl(var(--sb-border));
        border-radius: 14px;
        background: hsl(var(--sb-card));
        box-shadow: 0 12px 32px rgba(16, 24, 40, 0.16);
    }
    .acct-menu-head {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 10px 10px 12px;
    }
    .acct-menu-id {
        min-width: 0;
    }
    .acct-menu-email {
        font-size: 14px;
        font-weight: 600;
        color: hsl(var(--sb-foreground));
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .acct-menu-role {
        margin-top: 2px;
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.04em;
        color: hsl(var(--sb-primary));
    }
    .acct-item {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        padding: 10px;
        border: none;
        border-radius: 9px;
        background: transparent;
        color: hsl(var(--sb-foreground));
        font-size: 13px;
        text-align: left;
        cursor: pointer;
        transition: background 0.12s;
    }
    .acct-item:hover {
        background: hsl(var(--sb-muted));
    }
    .acct-item svg {
        width: 17px;
        height: 17px;
        flex-shrink: 0;
        color: hsl(var(--sb-muted-foreground));
    }
    .acct-item.danger {
        color: hsl(var(--sb-destructive));
    }
    .acct-item.danger svg {
        color: hsl(var(--sb-destructive));
    }
    .acct-sep {
        height: 1px;
        margin: 6px 4px;
        background: hsl(var(--sb-border));
    }
    .acct-lang-row {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 8px 10px;
    }
    .acct-lang-label {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 13px;
        color: hsl(var(--sb-foreground));
        white-space: nowrap;
    }
    .acct-lang-label svg {
        width: 17px;
        height: 17px;
        flex-shrink: 0;
        color: hsl(var(--sb-muted-foreground));
    }
    .acct-lang-seg {
        display: inline-flex;
        margin-left: auto;
        padding: 2px;
        gap: 2px;
        border: 1px solid hsl(var(--sb-border));
        border-radius: 9px;
        background: hsl(var(--sb-muted));
    }
    .acct-lang-opt {
        border: none;
        background: transparent;
        padding: 4px 9px;
        border-radius: 7px;
        font-size: 12px;
        font-weight: 600;
        color: hsl(var(--sb-muted-foreground));
        cursor: pointer;
        white-space: nowrap;
        transition:
            background 0.12s,
            color 0.12s;
    }
    .acct-lang-opt:hover {
        color: hsl(var(--sb-foreground));
    }
    .acct-lang-opt.active {
        background: hsl(var(--sb-card));
        color: hsl(var(--sb-foreground));
        box-shadow: 0 1px 2px rgba(16, 24, 40, 0.1);
    }
</style>
